export default "__VITE_ASSET__BBAKZL0B__"